import * as yup from 'yup';

export const bonusRuleFormSchema = yup.object({
    bonusPercent: yup
        .number()
        .required('Процент бонусов обязателен для заполнения')
        .min(0, 'Процент бонусов не может быть отрицательным')
        .max(100, 'Процент бонусов не может быть больше 100'),
    minOrderAmount: yup
        .number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' || originalValue === null || originalValue === undefined ? null : value))
        .optional()
        .min(0, 'Минимальная сумма заказа не может быть отрицательной'),
    maxBonusAmount: yup
        .number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' || originalValue === null || originalValue === undefined ? null : value))
        .optional()
        .min(0, 'Максимальная сумма бонусов не может быть отрицательной'),
    expiresDays: yup
        .number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' || originalValue === null || originalValue === undefined ? null : value))
        .optional()
        .min(1, 'Срок действия должен быть не менее 1 дня'),
    isActive: yup.boolean().default(true),
    startDate: yup.date().nullable().optional(),
    endDate: yup.date().nullable().optional(),
}) as yup.ObjectSchema<{
    bonusPercent: number;
    minOrderAmount?: number | null;
    maxBonusAmount?: number | null;
    expiresDays?: number | null;
    isActive: boolean;
    startDate?: Date | null;
    endDate?: Date | null;
}>;
